import { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2, Archive } from "lucide-react";
import { api } from "@/lib/api";
import { absUrl } from "@/components/MultiImageUpload";
import { useLang } from "@/context/LangContext";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Thumbnails of a resource's images + per-image download + "Tout télécharger" ZIP. */
export default function ResourceGallery({ resource, max = 6 }) {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const images = resource.images || [];
  const count = images.length + (resource.pdf_url ? 1 : 0);

  const downloadAll = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/resources/${resource.id}/download-link`);
      window.location.href = `${BACKEND}${data.url}`;
    } catch (err) {
      toast.error(err.response?.data?.detail || t("res_dl_error"));
    } finally {
      setTimeout(() => setBusy(false), 1500);
    }
  };

  return (
    <div className="mt-3" data-testid={`resource-gallery-${resource.id}`}>
      {images.length > 0 && (
        <div className="grid grid-cols-3 gap-1.5">
          {images.slice(0, max).map((img, i) => (
            <a key={img.url} href={absUrl(img.url)} download={img.filename || true} target="_blank" rel="noreferrer" title={`${t("res_dl_one")} ${img.filename || ""}`}
              className="group relative aspect-square overflow-hidden rounded-lg bg-neutral-100" data-testid={`resource-img-${resource.id}-${i}`}>
              <img src={absUrl(img.url)} alt={img.filename || resource.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
              <span className="absolute inset-0 grid place-items-center bg-black/0 text-white opacity-0 transition-opacity group-hover:bg-black/35 group-hover:opacity-100"><Download className="h-4 w-4" /></span>
              {i === max - 1 && images.length > max && <span className="absolute inset-0 grid place-items-center bg-black/55 text-sm font-bold text-white">+{images.length - max}</span>}
            </a>
          ))}
        </div>
      )}
      {count > 1 && (
        <button type="button" onClick={downloadAll} disabled={busy} className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-navy px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-wine-600 disabled:opacity-60" data-testid={`resource-dl-all-${resource.id}`}>
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Archive className="h-3 w-3" />} {t("res_dl_all").replace("{n}", count)}
        </button>
      )}
    </div>
  );
}
